module.exports = __webpack_public_path__ + "e0c61752.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/ClinicaMedica/17991.jpg
// module id = 1313
// module chunks = 0 1